import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ProfileDetails from "../components/my-account/profile-details/ProfileDetails";
import OrganizationDetails from "../components/my-account/organization-details/OrganizationDetails";
import { retrieveItem, storeItem } from "@src/helpers/functions";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  getMyOrganization,
  getMyOrganizationRequest,
} from "@src/redux";
import { useCheckPageComponentAccess } from "@src/hooks/index";

const MyAccount: React.FC = () => {
  const { t } = useTranslation();
  const sessionId = retrieveItem("sessionId");
  const { result } = useSelector(getMyOrganization);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(getMyOrganizationRequest({}));
  }, []);

  useEffect(() => {
    if (result?.id) {
      storeItem("my_org_result", { myOrgResult: result });
    }
  }, [result]);

  return (
    <div className="content">
      <div className="form-section">
        <div className="form-wrapper">
          <div className="my-accounting-header">
            <span className="form-heading">{t("profile")}</span>
          </div>
          <div className="profile_content">
            <ProfileDetails />
          </div>
        </div>
      </div>
      {useCheckPageComponentAccess("show_organization") ? (
        <div className="form-section">
          <div className="form-wrapper">
            <div className="my-accounting-header">
              <span className="form-heading">{t("my_organization")}</span>
            </div>
            <div className="my_organization_content">
              <OrganizationDetails 
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="form-section"></div>
      )}
    </div>
  );
};

export default MyAccount;
